import * as React from "react";
import { Route } from "react-router";
import { EventEmitter } from "fbemitter";

import { LabelStore } from "../flux/Label/LabelStore";
import { ListStore } from "../flux/Grid/ListStore";
import { SelectedItemsStore } from "../flux/Grid/SelectedItemsStore";
import { FlagStore } from "../flux/Flag/FlagStore";
import { ErrorStore } from "../flux/Error/ErrorStore";
import { DeleteObjectsStore } from "../flux/DeleteObjects";
import { EditCreatePersonStore } from "../components/Pages/Person/EditCreatePersonStore";

import { DeleteObjectsCommand } from "../components/Pages/commands/DeleteObjects";
import { UpsertPersonCommand } from "../components/Pages/Person/commands/UpsertPersonCommand";
import { InitUpsertPersonCommand } from "../components/Pages/Person/commands/InitUpsertPersonCommand";

import { SearchFn } from "../../rest/Search";
import { CommitFn } from "../../rest/Commit/index";
import { DeleteObjectsFn } from "../../rest/DeleteObjects";
import { Person, EntityType } from "../../models";
import { Polyglot } from "../../polyglot";
import { PersonRoute } from "../components/Pages/Person/PersonRoute";
import { routeFor } from "../routes";
import { SearchProps } from "../components/Pages/SearchProps";
import { TabSearchConfigurator } from "./configureSearchBox";

// This class is a configuration for Person tab
// Constructor receives and/or creates dependencies and injects them
export class PersonTab
{
    private readonly tableTitleStore = new LabelStore();
    private readonly listStore = new ListStore<Person>(person => person.id, EntityType.Person);
    private readonly selectedItemsStore = new SelectedItemsStore(this.listStore, EntityType.Person);
    private readonly deleteItemsStore = new DeleteObjectsStore(EntityType.Person);
    private readonly commitInProgressStore = new FlagStore();
    private readonly commitErrorStore = new ErrorStore();
    private readonly upserStore = new EditCreatePersonStore();
    private readonly divisionsLoadInProgress = new FlagStore();

    readonly markup: JSX.Element;
    readonly searchConfig: TabSearchConfigurator;
    
    constructor(polyglot: Polyglot, runSearch: SearchFn, commitEntity: CommitFn, deleteObjects: DeleteObjectsFn, getCurrentDivisionId: () => number, divisionEmitter: EventEmitter, IsAdmin: boolean)
    {
        this.searchConfig = new TabSearchConfigurator(polyglot, EntityType.Person, getCurrentDivisionId, divisionEmitter, this.tableTitleStore.dispatchToken);
        const deletePersonCommand = new DeleteObjectsCommand(EntityType.Person, this.deleteItemsStore, deleteObjects);
        const personUpsertCmd = new UpsertPersonCommand(polyglot, commitEntity, this.listStore.dispatchToken, this.commitInProgressStore.dispatchToken, this.commitErrorStore.dispatchToken);
        const personInitUpsertCmd = new InitUpsertPersonCommand(runSearch, this.upserStore, getCurrentDivisionId, this.divisionsLoadInProgress.dispatchToken, this.commitErrorStore.dispatchToken);

        this.markup = (
            <Route path={routeFor(EntityType.Person)} render={() => (
                <PersonRoute
                    polyglot={polyglot}
                    isAdmin={IsAdmin}
                    tableTitleStore={this.tableTitleStore}
                    listStore={this.listStore}
                    selectedItemsStore={this.selectedItemsStore}
                    deleteObjectsStore={this.deleteItemsStore}
                    deleteObjectsCommand={deletePersonCommand}

                    {...this.searchConfig.searchBoxProps}

                    upsertCommand={personUpsertCmd}
                    upsertInProgressStore={this.commitInProgressStore}
                    upsertErrorStore={this.commitErrorStore}
                    initUpsertCommand={personInitUpsertCmd}

                    editStore={this.upserStore}
                    divisionsLoadInProgress={this.divisionsLoadInProgress}
                />  
            )} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/init/person.tsx